import { MAX_DESCRIPTION_LENGTH } from 'modules/routes/constants/meta.js'
import { logUtil } from 'packages/src'

/**
 * @param props
 * @param props.musclesWorkedStr
 * @param props.equipmentStr
 */
function getDescriptionByIdExerciseSelectorUtil (props) {
  const {
    musclesWorkedStr,
    equipmentStr
  } = props

  logUtil('getDescriptionByIdExerciseSelectorUtil').debug('props=', props)
  const musclesWorkedLength = musclesWorkedStr.length
  if (musclesWorkedLength >= MAX_DESCRIPTION_LENGTH) {
    return musclesWorkedStr
  }

  const equipmentStrParts = equipmentStr.split('.')
  const firstPart = equipmentStrParts[0]
  if (musclesWorkedLength + firstPart.length >= MAX_DESCRIPTION_LENGTH) {
    return musclesWorkedStr
  }

  if (musclesWorkedLength + equipmentStr.length >= MAX_DESCRIPTION_LENGTH) {
    return `${musclesWorkedStr} ${firstPart}.`
  }

  return `${musclesWorkedStr} ${equipmentStr}`
}

export default getDescriptionByIdExerciseSelectorUtil
